import { Popover } from "@/components/Popover/Popover";
import ActivityDescriptionIcon from "@medoma/components/icons/ActivityDescriptionIcon";
import { useLingui } from "@lingui/react/macro";
import { TextWithLineBreaks } from "@medoma/components/Text/Text";

export const ActivityDescriptionPopover = ({
  description,
}: {
  description: string;
}) => {
  const { t } = useLingui();

  return (
    <Popover
      trigger={{
        icon: <ActivityDescriptionIcon />,
        ariaLabel: t`Visa beskrivning`,
      }}
    >
      <TextWithLineBreaks>{description}</TextWithLineBreaks>
    </Popover>
  );
};
